import React from "react";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../../components/SwitchToggle";

const BrandDetail = () => {
  const navigate = useNavigate();

  const packageInfo = [
    { label: "Brand Name", value: "Premium Plan" },
    { label: "Created Date", value: "01 March 2025" },
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Brand Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-brands")}>Manage Brands</button>{" "}
          – Brand Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img v2 w_33">
            <h6>Brand Cover Image</h6>
            <figure className="no_radius">
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div>
          <div className="vew_img w_33">
            <h6>Brand Logo</h6>
            <figure>
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div>
          <div className="w_33"></div>
          {packageInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
          <div className="w_33">
            <h6>Popular</h6>
            <SwitchToggle defaultChecked />
          </div>
          <div className="w_100">
            <h6>Description</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus tempora possimus neque nobis commodi harum repudiandae, ab delectus? Temporibus veniam quaerat nostrum iure libero nisi nihil eos, ipsa cupiditate est ex in architecto. Autem vel facilis eaque maiores, placeat quibusdam quam adipisci praesentium, accusantium, officiis est architecto quae? Possimus praesentium laborum voluptates ipsum modi, laboriosam laudantium assumenda itaque fugiat quis sint explicabo dolor molestiae sit amet at inventore sunt nemo odio expedita! Aperiam quas harum vel quam sapiente deleniti! Consectetur voluptate, placeat eos reiciendis eveniet pariatur nam? Dolorum repellat doloremque dicta perferendis inventore a quos quis odio, minus quasi recusandae.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandDetail;
